// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-bar[data-v-91448300]{background-color:#000;z-index:20001}.cursor-pointer[data-v-91448300]{cursor:pointer}.main-header__element--above[data-v-91448300]{position:relative;z-index:1}.TheTopNavigation_partnerName[data-v-91448300]{color:#adb1b2;font-size:15px;padding:0 4px 2px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
